<div class="row">
  <div class="col-6" *ngIf="peerProducts.length>0">
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Weights"></mat-tab>
      <mat-tab *ngIf="user" label="Risk"></mat-tab>
    </mat-tab-group>
    <br><br>
    <app-peers-widget-chart [ngClass]="{'d-none': !(selectedTab=='deconcentration' && peerProducts.length>0)}"
                            #enfchart [peerProducts]="peerProducts" target="deconcentration"
                            [originalPA]="originalPA" [investablePA]="investablePA" [protectedPA]="protectedPA"
                            [target1PA]="target1PA" [target2PA]="target2PA" [target3PA]="target3PA"
                            (selectedPeerChange)="onSelectedPeerChange($event)"
                            [selectedType]="selectedType" [selectedIndex]="selectedIndex"></app-peers-widget-chart>
    <app-peers-widget-chart [ngClass]="{'d-none': !(user && selectedTab=='diversification' && peerProducts.length>0)}"
                            #enfbchart [peerProducts]="peerProducts" target="diversification"
                            [originalPA]="originalPA" [investablePA]="investablePA" [protectedPA]="protectedPA"
                            [target1PA]="target1PA" [target2PA]="target2PA" [target3PA]="target3PA"
                            (selectedPeerChange)="onSelectedPeerChange($event)"
                            [selectedType]="selectedType" [selectedIndex]="selectedIndex"></app-peers-widget-chart>
  </div>

  <div class="col-6" style="height:630px">
    <app-peers-widget-summary *ngIf="peerAnalysis" [peerAnalysis]="peerAnalysis"></app-peers-widget-summary>
  </div>

</div>
<br>
<p style="font-size:0.75em; line-height:1.4em; color: grey;">The performance quoted represents past performance and does not guarantee future results. Investment return and principal value of an investment will fluctuate so that an investor's shares, when sold or redeemed, may be worth more or less than the original cost. Current performance may be lower or higher than the performance quoted.</p>

